var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-failure"},[_c('div',{staticClass:"login-failure__card"},[_c('h1',[_vm._v("Login Failure")]),_c('p',[_vm._v("An error occured when trying to log you in. Please try again:")]),_c('router-link',{staticClass:"login-failure__card__link",attrs:{"to":"'/login'"}},[_vm._v("\n      Login\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }